(function () {
  'use strict';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function fillSelect(select, values, placeholder) {
    var html = '<option value="">' + placeholder + '</option>';
    for (var i = 0; i < values.length; i++) {
      var v = values[i];
      html += '<option value="' + String(v).replace(/"/g, '&quot;') + '">' + v + '</option>';
    }
    select.innerHTML = html;
    select.disabled = values.length === 0;
    select.value = '';
    select.selectedIndex = 0;
  }

  function resetPlaceholders(yearEl, makeEl, modelEl, goEl) {
    if (yearEl) {
      yearEl.value = '';
      yearEl.selectedIndex = 0;
    }
    if (makeEl) {
      makeEl.value = '';
      makeEl.selectedIndex = 0;
    }
    if (modelEl) {
      modelEl.value = '';
      modelEl.selectedIndex = 0;
    }
    if (goEl) {
      goEl.disabled = true;
      goEl.setAttribute('aria-disabled', 'true');
    }
  }

  function encode(v) {
    return encodeURIComponent(v);
  }

  function init(root) {
    if (!root || root.dataset.ymmReady) return;
    root.dataset.ymmReady = '1';

    var yearEl = qs(root, '[data-ymm-year]');
    var makeEl = qs(root, '[data-ymm-make]');
    var modelEl = qs(root, '[data-ymm-model]');
    var goEl = qs(root, '[data-ymm-go]');
    if (!yearEl || !makeEl || !modelEl || !goEl) return;

    // Discourage browser form restore / autocomplete
    yearEl.setAttribute('autocomplete', 'off');
    makeEl.setAttribute('autocomplete', 'off');
    modelEl.setAttribute('autocomplete', 'off');
    yearEl.setAttribute('data-form-type', 'other');
    makeEl.setAttribute('data-form-type', 'other');
    modelEl.setAttribute('data-form-type', 'other');

    var tree = null;
    var jsonUrl = root.getAttribute('data-json-url');
    var collectionUrl = root.getAttribute('data-collection-url') || '/collections/all';

    function syncGo() {
      var ready = !!(yearEl.value && makeEl.value && modelEl.value);
      goEl.disabled = !ready;
      goEl.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }

    function onYear() {
      var y = yearEl.value;
      makeEl.value = '';
      modelEl.value = '';
      if (!y || !tree[y]) {
        fillSelect(makeEl, [], 'Make');
        fillSelect(modelEl, [], 'Model');
        syncGo();
        return;
      }
      fillSelect(makeEl, Object.keys(tree[y]), 'Make');
      fillSelect(modelEl, [], 'Model');
      syncGo();
    }

    function onMake() {
      var y = yearEl.value;
      var m = makeEl.value;
      modelEl.value = '';
      if (!y || !m || !tree[y] || !tree[y][m]) {
        fillSelect(modelEl, [], 'Model');
        syncGo();
        return;
      }
      fillSelect(modelEl, tree[y][m], 'Model');
      syncGo();
    }

    function onGo() {
      if (goEl.disabled) return;
      var y = yearEl.value;
      var make = makeEl.value;
      var model = modelEl.value;
      if (!y || !make || !model) return;
      var url =
        collectionUrl +
        '?filter.p.m.custom.fitment_make=' +
        encode(make) +
        '&filter.p.m.custom.fitment_model=' +
        encode(model) +
        '&filter.p.m.custom.fitment_year=' +
        encode(y);
      try {
        var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url += '&preview_theme_id=' + encode(preview);
      } catch (e) {}
      window.location.href = url;
    }

    yearEl.addEventListener('change', onYear);
    makeEl.addEventListener('change', onMake);
    modelEl.addEventListener('change', syncGo);
    goEl.addEventListener('click', onGo);

    fetch(jsonUrl, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('ymm json ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var rawTree = (data && data.tree) || {};
        // Cap years: keep 1950..(currentYear+1); drop junk like 2098-2103 from bad metafields
        var maxY = new Date().getFullYear() + 1;
        tree = {};
        Object.keys(rawTree).forEach(function (y) {
          var yi = parseInt(y, 10);
          if (!isFinite(yi) || yi < 1950 || yi > maxY) return;
          tree[y] = rawTree[y];
        });
        var yearKeys = Object.keys(tree).sort(function (a, b) {
          return parseInt(b, 10) - parseInt(a, 10);
        });
        // Years only — never pre-select a year/make/model (browser may try to restore)
        fillSelect(yearEl, yearKeys, 'Year');
        fillSelect(makeEl, [], 'Make');
        fillSelect(modelEl, [], 'Model');
        resetPlaceholders(yearEl, makeEl, modelEl, goEl);
        // Re-assert after paint in case the browser restores select values
        requestAnimationFrame(function () {
          resetPlaceholders(yearEl, makeEl, modelEl, goEl);
          setTimeout(function () {
            resetPlaceholders(yearEl, makeEl, modelEl, goEl);
          }, 50);
        });
      })
      .catch(function (err) {
        console.warn('[wr-ymm]', err);
        yearEl.disabled = true;
      });
  }

  function boot() {
    document.querySelectorAll('[data-wr-ymm]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
